import * as types from "./visitorTypeTypes.js";


export const fetchVisitorTypesRequest = () => ({
    type: types.FETCH_VISITOR_TYPES_REQUEST,
});

export const fetchVisitorTypesSuccess = (provinces) => ({
    type: types.FETCH_VISITOR_TYPES_SUCCESS,
    payload: provinces,
});

export const fetchVisitorTypesFailure = (error) => ({
    type: types.FETCH_VISITOR_TYPES_FAILURE,
    payload: error,
});


export const addVisitorTypesRequest = (visitorTypes, callback) => ({
    type: types.ADD_VISITOR_TYPES_REQUEST,
    payload: visitorTypes,
    callback,
  });
  
  export const addVisitorTypesSuccess = (visitorTypes) => ({
    type: types.ADD_VISITOR_TYPES_SUCCESS,
    payload: visitorTypes,
  });
  
  export const addVisitorTypesFailure = (error) => ({
    type: types.ADD_VISITOR_TYPES_FAILURE,
    payload: error,
  });



//FOR UPDATING SITES
export const updateVisitorTypesRequest = (updatedVisitorType) => ({
    type: types.UPDATE_VISITOR_TYPES_REQUEST,
    payload: updatedVisitorType,
});

export const updateVisitorTypesSuccess = (updatedVisitorType) => ({
    type: types.UPDATE_VISITOR_TYPES_SUCCESS,
    payload: updatedVisitorType,
});

export const updateVisitorTypesFailure = (error) => ({
    type: types.UPDATE_VISITOR_TYPES_FAILURE,
    payload: error,
});



//FOR DELETING SITES
export const deleteVisitorTypesRequest = (visitorType,id ) => (
    ////console.log(id),
    {
    type: types.DELETE_VISITOR_TYPES_REQUEST,
    payload: visitorType,
});

export const deleteVisitorTypesSuccess = (id) => (
    ////console.log(id),
    {
    type: types.DELETE_VISITOR_TYPES_SUCCESS,
    payload: id,
});

export const deleteVisitorTypesFailure = (error) => ({
    type: types.DELETE_VISITOR_TYPES_FAILURE,
    payload: error,
});



  